import { validUrlRegex } from '../regex';
import { isAbsoluteUrl } from './is-absolute-url';

interface ValidUrlOptions {
  allowRelativeUrl: boolean;
}

export const isValidUrl = (url?: string, options: ValidUrlOptions = { allowRelativeUrl: false }): boolean => {
  if (!url) return false;

  if (url.includes('127.0.0.1:10000') || url.includes('localhost:10000')) return true;

  if (isAbsoluteUrl(url)) {
    return url.match(validUrlRegex) !== null;
  }

  if (options.allowRelativeUrl && url === '/') return true;

  return false;
};
